import React from 'react';
import { Heading } from '../../../../../landing.common/heading';
import styles from './styles.module.scss';
import { StepsHowTo, HowToStep } from '../../../../../landing.common/steps.how.to';

const creditCardSteps: HowToStep[] = [
    {
        title: 'Заполните анкету',
        description: 'Запросим минимум данных, необходимых для расчета кредитного лимита',
    },
    {
        title: 'Узнайте свой кредитный\u00A0лимит',
        description: 'Покажем сумму, которую готовы одобрить вам банки',
    },
    {
        title: 'Выберите подходящие\u00A0условия',
        description: 'Предложим вам кредитные карты по лучшим условиям',
    },
    {
        title: 'Отправьте заявку и получите\u00A0карту',
        description: 'Поможем оформить и расскажем, где и как получить карту',
    },
];
export const HowToSelect: React.FC = () => {
    return (
        <div className={styles.root}>
            <Heading level={3} className={styles.title}>
                Как подобрать кредитную карту
            </Heading>
            <StepsHowTo steps={creditCardSteps} className={styles.cardWrapper} />
        </div>
    );
};
